import { Collection, MixinInterface } from "@mcleod/core";
import { Component, DataSourceMode, PrintableEvent, PrintableListener } from "..";
import { ListenerListDef } from "../base/ListenerListDef";
import { PrintableListenerDef } from "./PrintableListenerDef";

export class PrintableMixin extends Component implements MixinInterface {
    private _printable: boolean;
    private _printableDuringAdd: boolean;
    private _printableDuringSearch: boolean;
    private _printableDuringUpdate: boolean;

    get name(): string {
        return "Printable";
    }

    initialize() {
    }

    get printable(): boolean {
        const mode = this.getCurrentDataSourceMode();
        if ((mode === DataSourceMode.ADD && this.printableDuringAdd)
            || (mode === DataSourceMode.UPDATE && this.printableDuringUpdate)
            || (mode === DataSourceMode.SEARCH && this.printableDuringSearch)) {
            return true;
        }
        return this._printable == null ? false : this._printable;
    }

    set printable(value: boolean) {
        if (this.printableValueMatches(value) === true) {
            return;
        }
        this._printable = value;
        this.syncPrintable();
    }

    printableValueMatches(value: boolean) {
        return this._printable === value;
    }

    get printableDuringAdd(): boolean {
        return this._printableDuringAdd == null ? false : this._printableDuringAdd;
    }

    set printableDuringAdd(value: boolean) {
        this._printableDuringAdd = value;
        this.syncPrintable();
    }

    get printableDuringSearch(): boolean {
        return this._printableDuringSearch == null ? false : this._printableDuringSearch;
    }

    set printableDuringSearch(value: boolean) {
        this._printableDuringSearch = value;
        this.syncPrintable();
    }

    get printableDuringUpdate(): boolean {
        return this._printableDuringUpdate == null ? false : this._printableDuringUpdate;
    }

    set printableDuringUpdate(value: boolean) {
        this._printableDuringUpdate = value;
        this.syncPrintable();
    }

    protected syncPrintable() {
        this._applyPrintable(this.printable);
        this.syncCaptionIfPossible();
    }

    protected _applyPrintable(_value: boolean) {
        // Leave blank for components that don't change, such as Container
    }

    addPrintableListener(value: PrintableListener) {
        this.addEventListener(PrintableListenerDef.get(), value);
    }

    removePrintableListener(value: PrintableListener) {
        this.removeEventListener(PrintableListenerDef.get(), value);
    }

    firePrintableListeners(event: PrintableEvent) {
        this.fireListeners(PrintableListenerDef.get(), event);
    }

    get listenerDefs(): Collection<ListenerListDef> {
        return {
            "printable": { ...PrintableListenerDef.get() }
        };
    }
}
